// src/firebase.js

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration (Koral Krush project)
const firebaseConfig = {
  apiKey: "AIzaSyD64nvuE1mcaFRUeazAdxCchmkRfVms7Dk",
  authDomain: "koralkrush.firebaseapp.com",
  projectId: "koralkrush",
  storageBucket: "koralkrush.firebasestorage.app",
  messagingSenderId: "399585839342",
  appId: "1:399585839342:web:753b4bf83d50642ea38bff"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore, Auth, and Storage
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
